import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { ReportSummaryPayload } from '@rossum/api-client/internal';
import { api } from '../../../../lib/apiClient';
import { summarySchema } from '../constants';

export const useGetReportSummary = (payload?: ReportSummaryPayload) => {
  return useQuery({
    queryKey: ['summary', payload],
    queryFn: async () => {
      if (!payload) {
        return undefined;
      }
      const response = await api.request(
        endpoints.internal.reportSummary({ ...payload })
      );

      const parsed = summarySchema.safeParse(response);

      if (!parsed.success) {
        // oxlint-disable-next-line no-console
        console.error('Failed to parse summary', parsed.error);
        return undefined;
      }

      return parsed.data;
    },
    enabled: !!payload,
    staleTime: 1000 * 60 * 5,
  });
};
